import { render, staticRenderFns } from "./HistoricoCarteira.vue?vue&type=template&id=1802b896&"
import script from "./HistoricoCarteira.vue?vue&type=script&lang=js&"
export * from "./HistoricoCarteira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports